import React, { useState, useEffect } from "react";

import { Store } from "react-notifications-component";

import {
  getStages,
  getStatus,
  searchDropdownData,
  searchMentionUsers,
  createContact,
  saveInteraction,
} from "./Network_Calls";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    Autocomplete,
    MenuItem,
    Paper,
    Chip,
    IconButton,
    CircularProgress,
    Switch,
    FormControlLabel,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const AddInteractionDialog = ({
    open,
    onClose,
    implId,
    implementationName,
    journeyType,
    selectedCustomer,
  }) => {

  const [savingInteraction, setSavingInteraction] = useState(false);

  const [contactRows, setContactRows] = useState([
    {
      id: 1,
      contact: "",
      company: "",
    },
  ]);

  const [employeeRows, setEmployeeRows] = useState([
    {
      id: 1,
      employee: "",
    },
  ]);

  const [contactOptions, setContactOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  const [productOptions, setProductOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);

  const [interactionForm, setInteractionForm] = useState({
    products: [],
    projects: [],
  });

  const [interactionDetails, setInteractionDetails] = useState({
    interactionDate: new Date().toISOString().split("T")[0],
    stage: "",
    status: "",
    note: "",
  });

  const [interactionErrors, setInteractionErrors] = useState({});

  const [stageOptions, setStageOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const [mentionUsers, setMentionUsers] = useState([]);
  const [showMentionDropdown, setShowMentionDropdown] = useState(false);
  const [selectedMentions, setSelectedMentions] = useState([]);
  const [sendMentionEmail, setSendMentionEmail] = useState(false);

  const [openNewModal, setOpenNewModal] = useState(false);
  const [newModalType, setNewModalType] = useState("");
  const [newValue, setNewValue] = useState("");
  const [newReference, setNewReference] = useState("");
  const [savingEntity, setSavingEntity] = useState(false);

  useEffect(() => {
      if (implId) {
        fetchStages();
        fetchStatus();
      }
    }, [implId]);

    useEffect(() => {
    if (!open || !selectedCustomer) return;

    const externalId = selectedCustomer.external_id || "";
    const name = selectedCustomer.username || "";

    // Reset all fields
    setContactRows([
        {
            id: 1,
            contact: "",
            company: "",
        },
    ]);

    setEmployeeRows([
        {
            id: 1,
            employee: "",
        },
    ]);

    setInteractionForm({
        products: [],
        projects: [],
    });

    // Contact
    if (externalId.startsWith("Contact-")) {
        setContactRows([
            {
                id: 1,
                contact: name,
                company: "",
            },
        ]);
    }

    // Company / Customer
    else if (
        externalId.startsWith("Customer-") ||
        externalId.startsWith("Company-")
    ) {
        setContactRows([
            {
                id: 1,
                contact: "",
                company: name,
            },
        ]);
    }

    // Employee
    else if (externalId.startsWith("Employee-")) {
        setEmployeeRows([
            {
                id: 1,
                employee: name,
            },
        ]);
    }

    // Product
    else if (externalId.startsWith("Product-")) {
        setInteractionForm(prev => ({
            ...prev,
            products: [name],
        }));
    }

    // Project
    else if (externalId.startsWith("Project-")) {
        setInteractionForm(prev => ({
            ...prev,
            projects: [name],
        }));
    }

    // Fallback
    else {
        setContactRows([
            {
                id: 1,
                contact: name,
                company: "",
            },
        ]);
    }
  }, [open, selectedCustomer]);
  
    const fetchStages = async () => {
      try {
        const result = await getStages(implId);
  
        if (result?.list) {
          setStageOptions(result.list);
        }
      } catch (error) {
        console.log("Error fetching stages", error);
      }
    };
  
    const fetchStatus = async () => {
      try {
        const result = await getStatus(implId);
  
        if (result?.list) {
          setStatusOptions(result.list);
        }
      } catch (error) {
        console.log("Error fetching status", error);
      }
    };
  
    const searchContacts = async (searchText) => {
      if (!searchText || searchText.length < 3) {
        setContactOptions([]);
        return;
      }
  
      try {
        const result = await searchDropdownData({
          impl_id: implId,
          journey_type: journeyType,
          search_text: searchText,
        });
  
        setContactOptions(
          result.data.users.map((item) => ({
            label: item.username,
            value: item._id,
            raw: item,
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };
  
    const searchCompanies = async (searchText) => {
      if (!searchText || searchText.length < 3) {
        setCompanyOptions([]);
        return;
      }
  
      try {
        const result = await searchDropdownData({
          impl_id: implId,
          journey_type: "Customer",
          search_text: searchText,
        });
  
        setCompanyOptions(
          result.data.users.map((item) => ({
            label: item.username,
            value: item._id,
            raw: item,
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };
  
    const searchEmployees = async (searchText) => {
      if (!searchText || searchText.length < 3) {
        setEmployeeOptions([]);
        return;
      }
  
      try {
        const result = await searchDropdownData({
          impl_id: implId,
          journey_type: "Employee",
          search_text: searchText,
        });
  
        setEmployeeOptions(
          result.data.users.map((item) => ({
            label: item.username,
            value: item._id,
            raw: item,
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };
  
    const searchProducts = async (searchText) => {
      if (!searchText || searchText.length < 3) {
        setProductOptions([]);
        return;
      }
  
      try {
        const result = await searchDropdownData({
          impl_id: implId,
          journey_type: "Product",
          search_text: searchText,
        });
  
        setProductOptions(
          result?.data?.users?.map((item) => ({
            label: item.username,
            value: item._id,
            raw: item,
          })) || []
        );
      } catch (error) {
        console.log(error);
      }
    };
  
    const searchProjects = async (searchText) => {
      if (!searchText || searchText.length < 3) {
        setProjectOptions([]);
        return;
      }
  
      try {
        const result = await searchDropdownData({
          impl_id: implId,
          journey_type: "Project",
          search_text: searchText,
        });
  
        setProjectOptions(
          result?.data?.users?.map((item) => ({
            label: item.username,
            value: item._id,
            raw: item,
          })) || []
        );
      } catch (error) {
        console.log(error);
      }
    };
  
    const fetchMentionUsers = async (searchText) => {
      if (!searchText?.trim()) {
        setMentionUsers([]);
        return;
      }
  
      try {
        const result = await searchMentionUsers(searchText);
  
        setMentionUsers(result?.data?.users || []);
      } catch (error) {
        console.log(error);
      }
    };
   
  const handleNoteChange = async (e) => {

    const value = e.target.value;

    handleInteractionDetailsChange(
      "note",
      value
    );

    const match =
      value.match(/@([a-zA-Z0-9_]*)$/);

    if (match) {

      const keyword = match[1];

      // Trigger only after 3 characters
      if (keyword.length < 3) {
        setShowMentionDropdown(false);
        setMentionUsers([]);
        return;
      }

      setShowMentionDropdown(true);

      await fetchMentionUsers(
        keyword
      );

    } else {

      setShowMentionDropdown(false);
      setMentionUsers([]);
    }
  };

  const handleMentionSelect = (
    user
  ) => {

    const note =
      interactionDetails.note;

    const updatedNote =
      note.replace(
        /@([a-zA-Z0-9_]*)$/,
        `@${user.email} `
      );

    setInteractionDetails(
      (prev) => ({
        ...prev,
        note: updatedNote,
      })
    );

    setSelectedMentions(
      (prev) => {

        const exists =
          prev.some(
            (x) => x.id === user.id
          );

        if (exists) {
          return prev;
        }

        return [...prev, user];
      }
    );

    setShowMentionDropdown(false);
    setMentionUsers([]);
  };

  const openCreateModal = (type) => {
      setNewModalType(type);
      setOpenNewModal(true);
    };
  
    const closeCreateModal = () => {
      setOpenNewModal(false);
      setNewValue("");
      setNewReference("");
      setNewModalType("");
    };
  
    const defaultStage =
      stageOptions.find(
        (item) => item.stage?.toLowerCase() === "kyc"
      )?.stage ||
      stageOptions.find(
        (item) => item.stage?.toLowerCase() === "initial lead"
      )?.stage ||
      stageOptions?.[0]?.stage ||
      "";
  
    const defaultStatus =
      statusOptions.find(
        (item) => item.status?.toLowerCase() === "create"
      )?.status ||
      statusOptions?.[0]?.status ||
      "";
  
    const handleSaveNewEntity =
      async () => {
  
        if (!newValue.trim()) {
  
          Store.addNotification({
            title: "Validation",
  
            message:
              `${newModalType} name is required`,
  
            type: "warning",
  
            insert: "top",
  
            container: "top-right",
  
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
  
          return;
        }
  
        try {
           setSavingEntity(true);
          /*
          =====================================
          CHECK DUPLICATE
          =====================================
          */
  
          let optionsToCheck = [];
  
          if (newModalType === "Contact") {
            optionsToCheck = contactOptions;
          }
          else if (newModalType === "Employee") {
            optionsToCheck = employeeOptions;
          }
          else if (newModalType === "Company") {
            optionsToCheck = companyOptions;
          }
  
          const alreadyExists =
            optionsToCheck.some(
              (x) =>
                x.label
                  ?.toLowerCase()
                  .trim() ===
                newValue
                  .toLowerCase()
                  .trim()
            );
  
          if (alreadyExists) {
  
            Store.addNotification({
              title: "Validation",
  
              message:
                `${newModalType} already exists`,
  
              type: "warning",
  
              insert: "top",
  
              container: "top-right",
  
              dismiss: {
                duration: 3000,
                onScreen: true,
              },
            });
            setSavingEntity(false);
            return;
          }
  
          if (
            newModalType === "Contact"
          ) {
  
            const payload = {
              impl_id: implId,
              entity_name: newValue,
              reference: newReference,
              journey_type: "Contact360",
              stage_name: interactionDetails.stage || defaultStage,
              status_name: interactionDetails.status || defaultStatus,
            };
  
            console.log(
              "CREATE CONTACT PAYLOAD",
              payload
            );
  
            const result =
              await createContact(
                payload
              );
  
            if (
              result.status === 200
            ) {
  
              const newOption = {
  
                label: newValue,
  
                value:
                  result.data
                    .contact_id,
              };
  
              setContactOptions(
                (prev) => [
                  ...prev,
                  newOption,
                ]
              );
  
              setContactRows(prev => {
  
                const updated = [...prev];
  
                updated[updated.length - 1] = {
                  ...updated[updated.length - 1],
                  contact: newValue,
                };
  
                return updated;
              });
  
              Store.addNotification({
                title: "Success",
  
                message:
                  "Contact created successfully",
  
                type: "success",
  
                insert: "top",
  
                container:
                  "top-right",
  
                dismiss: {
                  duration: 3000,
                  onScreen: true,
                },
              });
  
              closeCreateModal();
              setSavingEntity(false);
              return;
            }
          }
  
          if (newModalType === "Employee") {
  
            const payload = {
              impl_id: implId,
              external_id: `manual_${Date.now()}`,
              entity_name: newValue,
              reference: newReference,
              journey_type: "Employee",
              stage_name: interactionDetails.stage || defaultStage,
              status_name: interactionDetails.status || defaultStatus,
            };
  
            const result =
              await createContact(payload);
  
            if (result.status === 200) {
  
              const newOption = {
                label: newValue,
                value: result.data.contact_id,
              };
  
              setEmployeeOptions((prev) => [
                ...prev,
                newOption,
              ]);
  
              setEmployeeRows(prev => {
  
                const updated = [...prev];
  
                updated[updated.length - 1] = {
                  ...updated[updated.length - 1],
                  employee: newValue,
                };
  
                return updated;
              });
  
              Store.addNotification({
                title: "Success",
                message: "Employee created successfully",
                type: "success",
                insert: "top",
                container: "top-right",
                dismiss: {
                  duration: 3000,
                  onScreen: true,
                },
              });
  
              closeCreateModal();
              setSavingEntity(false);
              return;
            }
          }
  
          if (newModalType === "Company") {
  
            const payload = {
              impl_id: implId,
              external_id: `manual_${Date.now()}`,
              entity_name: newValue,
              reference: newReference,
              journey_type: "Customer",
              stage_name: interactionDetails.stage || defaultStage,
              status_name: interactionDetails.status || defaultStatus,
            };
  
            const result =
              await createContact(payload);
  
            if (result.status === 200) {
  
              const newOption = {
                label: newValue,
                value: result.data.contact_id,
              };
  
              setCompanyOptions(prev => [
                ...prev,
                newOption,
              ]);
  
              setContactRows(prev => {
  
                const updated = [...prev];
  
                updated[updated.length - 1] = {
                  ...updated[updated.length - 1],
                  company: newValue,
                };
  
                return updated;
              });
  
              Store.addNotification({
                title: "Success",
                message: "Company created successfully",
                type: "success",
                insert: "top",
                container: "top-right",
                dismiss: {
                  duration: 3000,
                  onScreen: true,
                },
              });
  
              closeCreateModal();
              setSavingEntity(false);
              return;
            }
          }
  
          /*
          =====================================
          LOCAL COMPANY / EMPLOYEE
          =====================================
          */
  
          const newOption = {
            label: newValue,
            value: `new_${Date.now()}`,
            reference: newReference,
          };
  
          if (
              newModalType === "Company"
          ) {
  
            setCompanyOptions(
              (prev) => [
                ...prev,
                newOption,
              ]
            );
  
            const updatedRows =
              [...contactRows];
  
            updatedRows[
              updatedRows.length - 1
            ].company = newValue;
  
            setContactRows(
              updatedRows
            );
          }
  
          else if (
            newModalType ===
            "Employee"
          ) {
  
            setEmployeeOptions(
              (prev) => [
                ...prev,
                newOption,
              ]
            );
  
            const updatedRows =
              [...employeeRows];
  
            updatedRows[
              updatedRows.length - 1
            ].employee = newValue;
  
            setEmployeeRows(
              updatedRows
            );
          }
  
          Store.addNotification({
            title: "Success",
  
            message:
              `${newModalType} added successfully`,
  
            type: "success",
  
            insert: "top",
  
            container: "top-right",
  
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
  
          closeCreateModal();
          setSavingEntity(false);
        } catch (error) {
  
          console.log(error);
          setSavingEntity(false);
          Store.addNotification({
            title: "Error",
  
            message:
              error?.response?.data
                ?.message ||
              `Failed to add ${newModalType}`,
  
            type: "danger",
  
            insert: "top",
  
            container: "top-right",
  
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
        }
    };

    const validateInteractionForm = () => {
    let errors = {};

    // CONTACT VALIDATION
    const validContacts = contactRows.filter(
      (row) =>
        row.contact?.trim() !== "" &&
        row.company?.trim() !== ""
    );

    if (validContacts.length === 0) {
      errors.contacts =
        "At least one Contact and Company is required";
    }

    // DATE
    if (!interactionDetails.interactionDate) {
      errors.interactionDate =
        "Interaction Date is required";
    }

    // STAGE
    if (!interactionDetails.stage) {
      errors.stage = "Stage is required";
    }

    // STATUS
    if (!interactionDetails.status) {
      errors.status = "Status is required";
    }

    setInteractionErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSaveInteraction = async () => {
  
      const isValid = validateInteractionForm();
  
      if (!isValid) {
        return;
      }
      
      try {
        setSavingInteraction(true);
         const formattedContacts =
          contactRows
            .filter(
              (row) =>
                row.contact?.trim() &&
                row.company?.trim()
            )
            .map((row) => {
  
            const selectedContact =
              contactOptions.find(
                (x) => x.label === row.contact
              );
  
            const selectedCompany =
              companyOptions.find(
                (x) => x.label === row.company
              );
  
            return {
              contact_id:
                selectedContact?.value || null,
  
              contact_name:
                row.contact || "",
  
              company_id:
                selectedCompany?.value || null,
  
              company_name:
                row.company || "",
            };
          });
  
        const employees =
          employeeRows
            .filter((row) => row.employee)
            .map((row) => {
  
              const selectedEmployee =
                employeeOptions.find(
                  (x) =>
                    x.label === row.employee
                );
  
              return {
                employee_id:
                  selectedEmployee?.value || null,
  
                employee_name:
                  row.employee || "",
              };
            });
        const products = interactionForm.products || [];
  
        const projects = interactionForm.projects || [];
  
        const cleanedNote = interactionDetails.note
        .replace(/@\S+/g, "")
        .replace(/\s+/g, " ")
        .trim();
  
        const payload = {
          implementation_name: implementationName,
          interactionDate: interactionDetails.interactionDate,
          stage: interactionDetails.stage,
          status: interactionDetails.status,
          note: cleanedNote,
          mentions: selectedMentions,
          sendMentionEmail,
          products,
          projects,
          contacts: formattedContacts,
          employees,
      };
  
  
        console.log(
          "SAVE INTERACTION PAYLOAD",
          payload
        );
  
        const result = await saveInteraction(payload);
  
        if (result.status === 200) {
  
          Store.addNotification({
            title: "Success",
  
            message: "Interaction saved successfully",
  
            type: "success",
  
            insert: "top",
  
            container: "top-right",
  
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
          setSavingInteraction(false);
          handleCloseInteraction();
  
        } else {
  
          setSavingInteraction(false);
          Store.addNotification({
            title: "Error",
  
            message:
              "Failed to save interaction",
  
            type: "danger",
  
            insert: "top",
  
            container: "top-right",
  
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
        }
  
      } catch (error) {
        setSavingInteraction(false);
        console.log(
          "SAVE INTERACTION ERROR",
          error
        );
  
        Store.addNotification({
          title: "Error",
  
          message:
            error?.response?.data?.error ||
            "Something went wrong",
  
          type: "danger",
  
          insert: "top",
  
          container: "top-right",
  
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
      }
      finally {
  
        setSavingInteraction(false);
      }
    };

    const handleCloseInteraction = () => {
        onClose();
        
        // RESET CONTACT ROWS
        setContactRows([
          {
            id: 1,
            contact: "",
            company: "",
          },
        ]);
    
        setEmployeeRows([
          {
            id: 1,
            employee: "",
          },
        ]);
    
        // RESET PRODUCTS / PROJECTS
        setInteractionForm({
          products: [],
          projects: [],
        });
    
        // RESET INTERACTION DETAILS
        setInteractionDetails({
          interactionDate: new Date().toISOString().split("T")[0],
          stage: "",
          status: "",
          note: "",
        });
    
       
        // RESET VALIDATION ERRORS
        setInteractionErrors({});
    
        // RESET NEW MODAL
        setOpenNewModal(false);
        setNewModalType("");
        setNewValue("");
      };
  const handleContactChange = (id, field, value) => {
    const updatedRows = contactRows.map((row) => {
      if (row.id === id) {
        return {
          ...row,
          [field]: value,
        };
      }

      return row;
    });

    setContactRows(updatedRows);
  };

  const handleInteractionFormChange = (
    field,
    value
  ) => {
    setInteractionForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleInteractionDetailsChange = (
    field,
    value
  ) => {
    setInteractionDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleEmployeeChange = (
        id,
        value
      ) => {

    const updated =
      employeeRows.map((row) => {

        if (row.id === id) {

          return {
            ...row,
            employee: value,
          };
        }

        return row;
      });

    setEmployeeRows(updated);
  };

 const handleDeleteContactRow = (id) => {

  if (contactRows.length === 1) {

    setContactRows([
      {
        id: 1,
        contact: "",
        company: "",
      },
    ]);

    return;
  }

  const filtered =
    contactRows.filter(
      (row) => row.id !== id
    );

    setContactRows(filtered);
  };

  const handleAddContactRow = () => {
    setContactRows((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        contact: "",
        company: "",
      },
    ]);
  };

  const handleAddEmployeeRow = () => {

    setEmployeeRows((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        employee: "",
      },
    ]);
  };

  const handleDeleteEmployeeRow = (id) => {

    if (employeeRows.length === 1) {

      setEmployeeRows([
        {
          id: 1,
          employee: "",
        },
      ]);

      return;
    }

    const filtered =
      employeeRows.filter(
        (row) => row.id !== id
      );

    setEmployeeRows(filtered);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={open}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "700",
          }}
        >
          Add Interaction

          <IconButton onClick={handleCloseInteraction}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <br></br>
            <div>
              {/* HEADER */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <TextField
                fullWidth
                type="date"
                label="Interaction Date"
                value={interactionDetails.interactionDate}
                onChange={(e) =>
                  handleInteractionDetailsChange(
                    "interactionDate",
                    e.target.value
                  )
                }
                error={!!interactionErrors.interactionDate}
                helperText={
                  interactionErrors.interactionDate
                }
                InputLabelProps={{ shrink: true }}
              />

              </div>
              

              {/* CONTACTS SECTION */}
              <div
                style={{
                  border: "1px solid #E3E8EF",
                  borderRadius: "14px",
                  padding: "20px",
                  marginBottom: "1.5rem",
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "1rem",
                    alignItems: "center",
                  }}
                >
                  <h3
                    style={{
                      margin: 0,
                      color: "#1FAFC2",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    Contacts
                  </h3>

                  <Button
                    variant="outlined"
                    onClick={handleAddContactRow}
                    style={{
                      borderColor: "#1FAFC2",
                      color: "#1FAFC2",
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: "600",
                    }}
                  >
                    + Add More Contact
                  </Button>
                </div>

                {contactRows.map((row, index) => (
                  <div
                    key={row.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "60px 1fr 110px 1fr 110px 60px",
                      gap: "12px",
                      alignItems: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        color: "#666",
                      }}
                    >
                      {index + 1}
                    </div>

                    {/* CONTACT */}
                    <Autocomplete
                      fullWidth
                      options={contactOptions.map((x) => x.label)}
                      value={row.contact}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                      }}
                      onChange={(event, value) => {
                        handleContactChange(
                          row.id,
                          "contact",
                          value || ""
                        );
                      }}
                      onInputChange={(event, newInputValue) => {
                        handleContactChange(
                          row.id,
                          "contact",
                          newInputValue
                        );

                        if (newInputValue.length >= 3) {
                          searchContacts(newInputValue);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Contact Name"
                          placeholder="Enter or Search Contact"
                        />
                      )}
                    />

                    <Button
                      variant="outlined"
                      onClick={() => openCreateModal("Contact")}
                      style={{
                        height: "55px",
                        borderColor: "#1FAFC2",
                        color: "#1FAFC2",
                        textTransform: "none",
                      }}
                    >
                      + New
                    </Button>

                    {/* COMPANY */}
                    <Autocomplete
                      fullWidth
                      options={companyOptions.map((x) => x.label)}
                      value={row.company}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                      }}
                      onChange={(event, value) => {
                        handleContactChange(
                          row.id,
                          "company",
                          value || ""
                        );
                      }}
                      onInputChange={(event, newInputValue) => {
                        handleContactChange(
                          row.id,
                          "company",
                          newInputValue
                        );

                        if (newInputValue.length >= 3) {
                          searchCompanies(newInputValue);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Company"
                          placeholder="Enter or Search Company"
                        />
                      )}
                    />

                    <Button
                      variant="outlined"
                      onClick={() => openCreateModal("Company")}
                      style={{
                        height: "55px",
                        borderColor: "#1FAFC2",
                        color: "#1FAFC2",
                        textTransform: "none",
                      }}
                    >
                      + New
                    </Button>

                    <IconButton
                      onClick={() => handleDeleteContactRow(row.id)}
                      style={{
                        background: "#FFF1F0",
                        border: "1px solid #FFD6D2",
                      }}
                    >
                      🗑️
                    </IconButton>
                  </div>
                ))}
              </div>
              {interactionErrors.contacts && (
                <div
                  style={{
                    color: "red",
                    fontSize: "13px",
                    marginBottom: "1rem",
                    marginTop: "-10px",
                    fontWeight: "500",
                  }}
                >
                  {interactionErrors.contacts}
                </div>
              )}

              <div
                style={{
                  border: "1px solid #E3E8EF",
                  borderRadius: "14px",
                  padding: "20px",
                  marginBottom: "1.5rem",
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "1rem",
                    alignItems: "center",
                  }}
                >
                  <h3
                    style={{
                      margin: 0,
                      color: "#1FAFC2",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    Employees
                  </h3>

                  <Button
                    variant="outlined"
                    onClick={handleAddEmployeeRow}
                    style={{
                      borderColor: "#1FAFC2",
                      color: "#1FAFC2",
                      textTransform: "none",
                      borderRadius: "8px",
                      fontWeight: "600",
                    }}
                  >
                    + Add Employee
                  </Button>
                </div>

                {employeeRows.map((row, index) => (
                  <div
                    key={row.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "60px 1fr 110px 60px",
                      gap: "12px",
                      alignItems: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        color: "#666",
                      }}
                    >
                      {index + 1}
                    </div>

                    <Autocomplete
                      fullWidth
                      options={employeeOptions.map(
                        (x) => x.label
                      )}
                      value={row.employee}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option
                            .toLowerCase()
                            .includes(
                              state.inputValue.toLowerCase()
                            )
                        );
                      }}
                      onChange={(event, value) => {
                        handleEmployeeChange(
                          row.id,
                          value || ""
                        );
                      }}
                      onInputChange={(
                        event,
                        newInputValue
                      ) => {

                        handleEmployeeChange(
                          row.id,
                          newInputValue
                        );

                        if (newInputValue.length >= 3) {
                          searchEmployees(newInputValue);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Employee"
                          placeholder="Search Employee"
                        />
                      )}
                    />

                    <Button
                      variant="outlined"
                      onClick={() =>
                        openCreateModal("Employee")
                      }
                      style={{
                        height: "55px",
                        borderColor: "#1FAFC2",
                        color: "#1FAFC2",
                        textTransform: "none",
                      }}
                    >
                      + New
                    </Button>

                    <IconButton
                      onClick={() =>
                        handleDeleteEmployeeRow(row.id)
                      }
                      style={{
                        background: "#FFF1F0",
                        border: "1px solid #FFD6D2",
                      }}
                    >
                      🗑️
                    </IconButton>
                  </div>
                ))}
              </div>

              {/* PRODUCTS + PROJECTS */}
              <div
                style={{
                  border: "1px solid #E3E8EF",
                  borderRadius: "14px",
                  padding: "20px",
                  marginBottom: "1.5rem",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1.5rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  {/* PRODUCTS */}
                  <div>
                    <Autocomplete
                      multiple
                      fullWidth
                      options={productOptions.map((x) => x.label)}
                      value={interactionForm.products}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option
                            .toLowerCase()
                            .includes(
                              state.inputValue.toLowerCase()
                            )
                        );
                      }}
                      onChange={(event, newValue) => {
                        handleInteractionFormChange(
                          "products",
                          newValue
                        );
                      }}
                      onInputChange={(event, value) => {

                        if (value.length >= 3) {
                          searchProducts(value);
                        }
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            label={option}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Products (Optional)"
                          placeholder="Type and press Enter"
                        />
                      )}
                    />
                  </div>

                  {/* PROJECTS */}
                  <div>
                    <Autocomplete
                      multiple
                      fullWidth
                      options={projectOptions.map((x) => x.label)}
                      value={interactionForm.projects}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option
                            .toLowerCase()
                            .includes(
                              state.inputValue.toLowerCase()
                            )
                        );
                      }}
                      onChange={(event, newValue) => {
                        handleInteractionFormChange(
                          "projects",
                          newValue
                        );
                      }}
                      onInputChange={(event, value) => {
                        if (value.length >= 3) {
                          searchProjects(value);
                        }
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            label={option}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Projects (Optional)"
                          placeholder="Type and press Enter"
                        />
                      )}
                    />
                  </div>
                </div>

                {/* STAGE / STATUS / DATE */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "1.5rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  <TextField
                    select
                    fullWidth
                    label="Stage"
                    value={interactionDetails.stage}
                    onChange={(e) =>
                      handleInteractionDetailsChange(
                        "stage",
                        e.target.value
                      )
                    }
                    error={!!interactionErrors.stage}
                    helperText={interactionErrors.stage}
                  >

                    {stageOptions.map(
                      (stageObj, index) => (

                        <MenuItem
                          key={index}
                          value={stageObj.stage}
                        >
                          {stageObj.stage}
                        </MenuItem>

                      )
                    )}

                  </TextField>

                  <TextField
                    select
                    fullWidth
                    label="Status"
                    value={interactionDetails.status}
                    onChange={(e) =>
                      handleInteractionDetailsChange(
                        "status",
                        e.target.value
                      )
                    }
                    error={!!interactionErrors.status}
                    helperText={interactionErrors.status}
                  >

                    {statusOptions.map(
                      (statusObj) => (

                        <MenuItem
                          key={statusObj.id}
                          value={statusObj.status}
                        >
                          {statusObj.status}
                        </MenuItem>

                      )
                    )}

                  </TextField>

                </div>

                {/* NOTE */}
                <div style={{ position: "relative" }}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Notes"
                    value={interactionDetails.note}
                    onChange={handleNoteChange}
                  />

                  {showMentionDropdown &&
                    mentionUsers.length > 0 && (
                      <Paper
                        elevation={3}
                        style={{
                          position: "absolute",
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          zIndex: 9999,
                        }}
                      >
                        {mentionUsers.map((user) => (
                          <MenuItem
                            key={user.id}
                            onClick={() =>
                              handleMentionSelect(user)
                            }
                          >
                            <div>
                              <small>{user.email}</small>
                            </div>
                          </MenuItem>
                        ))}
                      </Paper>
                    )}
                </div>
              </div>

              {/* FOOTER */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleCloseInteraction}
                  style={{
                    borderColor: "#1FAFC2",
                    color: "#1FAFC2",
                    textTransform: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: "600",
                  }}
                >
                  Cancel
                </Button>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px",
                    paddingTop: "15px"
                  }}
                >
                  
                    <FormControlLabel
                      control={
                        <Switch
                          checked={sendMentionEmail}
                          onChange={(e) =>
                            setSendMentionEmail(
                              e.target.checked
                            )
                          }
                          color="primary"
                        />
                      }
                      label="Send Email"
                    />

                <Button
                  variant="contained"
                  onClick={handleSaveInteraction}
                  disabled={savingInteraction}
                  style={{
                    backgroundColor: "#FF762B",
                    color: "#fff",
                    textTransform: "none",
                    padding: "12px 32px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    boxShadow: "none",
                    opacity: savingInteraction ? 0.8 : 1,
                  }}
                >
                  {savingInteraction && (
                    <CircularProgress
                      size={18}
                      style={{
                        color: "#fff",
                        marginRight: "10px",
                        verticalAlign: "middle",
                      }}
                    />
                  )}

                  {savingInteraction
                    ? (
                        "Saving..."
                      )
                    : (
                        "Save Interaction"
                      )}
                </Button>
                </div>
              </div>
            </div>
          
          <Dialog
            open={openNewModal}
            onClose={closeCreateModal}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              Add New {newModalType}

              <IconButton onClick={closeCreateModal}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <div
                style={{
                  paddingTop: "10px",
                }}
              >
                <TextField
                  fullWidth
                  label={`${newModalType} Name`}
                  value={newValue}
                  onChange={(e) => setNewValue(e.target.value)}
                  placeholder={`Enter ${newModalType} name`}
                />

                <TextField
                  fullWidth
                  label="Reference Email"
                  value={newReference}
                  onChange={(e) =>
                    setNewReference(e.target.value)
                  }
                  placeholder={`Enter ${newModalType} reference Email`}
                  style={{
                    marginTop: "15px",
                  }}
                />

                <div
                  style={{
                    marginTop: "1.5rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={closeCreateModal}
                    style={{
                      borderColor: "#1FAFC2",
                      color: "#1FAFC2",
                      textTransform: "none",
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleSaveNewEntity}
                    disabled={savingEntity}
                    style={{
                      backgroundColor: "#FF762B",
                      color: "#fff",
                      textTransform: "none",
                    }}
                  >
                    {savingEntity ? (
                      <>
                        <CircularProgress
                          size={16}
                          style={{
                            color: "#fff",
                            marginRight: "8px",
                          }}
                        />
                        Saving...
                      </>
                    ) : (
                      `Save ${newModalType}`
                    )}
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>     
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddInteractionDialog;